var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-btn',{attrs:{"small":"","fab":"","color":"purple","disabled":!_vm.link.length},on:{"click":function($event){return _vm.openLink(_vm.link)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-clipboard-text-search-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }